import { render, staticRenderFns } from "./programa-detalhe.vue?vue&type=template&id=60d798d7&"
import script from "./programa-detalhe.vue?vue&type=script&lang=js&"
export * from "./programa-detalhe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports